import { PayloadAction } from "@reduxjs/toolkit";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import {
  IApiResponse,
  ICreatePalletsResponse,
  IImportMaterialRequirementRequest,
  IMaterialRequirementCreateSuggestPalletRequest,
  IUpdateMaterialRequirementRequest,
} from "model";
import { IErrorResponse } from "model/Common/IErrorResponse";
import { call, put, takeEvery } from "redux-saga/effects";
import { MaterialRequirementActions } from "redux/actions";
import { MaterialRequirementApiService } from "services";

function* importMaterialRequirement(
  action: PayloadAction<IImportMaterialRequirementRequest>
) {
  try {
    const result: ICreatePalletsResponse = yield call(
      MaterialRequirementApiService.importMaterialRequirement,
      action.payload
    );
    if (result.succeeded) {
      yield put(
        MaterialRequirementActions.importMaterial.success(result.data!)
      );
      AlertHelper.showAlert(
        "Nhập phiếu yêu cầu nguyên liệu thành công",
        EAlertType.SUCCESS
      );
    } else {
      const error = result as IErrorResponse;
      yield put(MaterialRequirementActions.importMaterial.failed(error));
    }
  } catch (error) {
    yield put(MaterialRequirementActions.importMaterial.failed(error));
  }
}

function* importMoveMaterial(
  action: PayloadAction<IImportMaterialRequirementRequest>
) {
  try {
    const result: ICreatePalletsResponse = yield call(
      MaterialRequirementApiService.importMoveMaterial,
      action.payload
    );
    if (result.succeeded) {
      yield put(
        MaterialRequirementActions.importMaterial.success(result.data!)
      );
      AlertHelper.showAlert(
        "Nhập phiếu chuyển kho nguyên liệu thành công",
        EAlertType.SUCCESS
      );
    } else {
      const error = result as IErrorResponse;
      yield put(MaterialRequirementActions.importMaterial.failed(error));
    }
  } catch (error) {
    yield put(MaterialRequirementActions.importMaterial.failed(error));
  }
}

function* importMoveBag(
  action: PayloadAction<IImportMaterialRequirementRequest>
) {
  try {
    const result: ICreatePalletsResponse = yield call(
      MaterialRequirementApiService.importMoveBag,
      action.payload
    );
    if (result.succeeded) {
      yield put(MaterialRequirementActions.importMoveBag.success(result.data!));
      AlertHelper.showAlert(
        "Nhập phiếu chuyển kho bao bì thành công",
        EAlertType.SUCCESS
      );
    } else {
      const error = result as IErrorResponse;
      yield put(MaterialRequirementActions.importMoveBag.failed(error));
    }
  } catch (error) {
    yield put(MaterialRequirementActions.importMoveBag.failed(error));
  }
}

function* createBookedPallet(
  action: PayloadAction<IMaterialRequirementCreateSuggestPalletRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      MaterialRequirementApiService.createSuggestPalletMaterialRequirement,
      action.payload
    );
    if (result.succeeded) {
      yield put(
        MaterialRequirementActions.createBookedPallet.success(result.data!)
      );
      AlertHelper.showAlert("Tạo booking thành công", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(MaterialRequirementActions.createBookedPallet.failed(error));
    }
  } catch (error) {
    yield put(MaterialRequirementActions.createBookedPallet.failed(error));
  }
}

function* updateMaterialRequisition(
  action: PayloadAction<IUpdateMaterialRequirementRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      MaterialRequirementApiService.updateMaterialRequirement,
      action.payload
    );
    if (result.succeeded) {
      yield put(
        MaterialRequirementActions.updateMaterialRequirement.success(
          result.data!
        )
      );
      AlertHelper.showAlert("Cập nhật thành công", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(
        MaterialRequirementActions.updateMaterialRequirement.failed(error)
      );
    }
  } catch (error) {
    yield put(
      MaterialRequirementActions.updateMaterialRequirement.failed(error)
    );
  }
}

export function* Watcher() {
  yield takeEvery(
    MaterialRequirementActions.importMaterial.request,
    importMaterialRequirement
  );
  yield takeEvery(
    MaterialRequirementActions.importMoveMaterial.request,
    importMoveMaterial
  );
  yield takeEvery(
    MaterialRequirementActions.importMoveBag.request,
    importMoveBag
  );
  yield takeEvery(
    MaterialRequirementActions.createBookedPallet.request,
    createBookedPallet
  );
  yield takeEvery(
    MaterialRequirementActions.updateMaterialRequirement.request,
    updateMaterialRequisition
  );
}
